import React from 'react';
import Helmet from 'react-helmet';
import { Footer } from '../app/components';

const NotFoundPage = () => (
  <div>
    <div className="properties-page not-found">
      <Helmet title="Ekkert fannst - Húsfinnur" />
      <h2>Ekkert fannst :(</h2>
    </div>
    <Footer />
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/browser/notfound/NotFoundPage.js